import { render, staticRenderFns } from "./Bmgl.vue?vue&type=template&id=319e4efe&scoped=true&"
import script from "./Bmgl.vue?vue&type=script&lang=js&"
export * from "./Bmgl.vue?vue&type=script&lang=js&"
import style0 from "./Bmgl.vue?vue&type=style&index=0&id=319e4efe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e4efe",
  null
  
)

export default component.exports